module.exports = __webpack_public_path__ + "static/media/paper.a49dbffe.png";